module.exports = __webpack_public_path__ + "img/banner-1.b09087fb.svg";